/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace variable-name align */

import {ProjectElement}         from './project.element';
import {ProjectElementType}     from './project.element.type';
import {Project}                from '../project';
import {ProjectElementFactoryDecorator} from "@/models/project/project.element.factory.decorator";

/**
 *
 * @class ResultsElement
 *
 * @brief container for all the outputs of a simulation
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
@ProjectElementFactoryDecorator('SnapshotsElement')
export class SnapshotsElement extends ProjectElement {

  /** standard constructor */
  constructor(
    project: Project,
         id: string,
     parent: ProjectElement,
    publish?: boolean
  ) {

    super(project, id, ProjectElementType.Snapshots);

    this._acceptsElements.push(ProjectElementType.Blob);

    this._enabled     = true;
    this._label       = 'Snapshots';
    this._icon        = '';
    this._elementKind = 'Snapshots';

    if (parent) {

      this._project.addElement(this, parent, publish);
    }

  }

  /** helper to use to for static global constructors (and factory registration) */
  static requireType() {
    console.log("requiring SnapshotsElement");
  }
}
